export const ControlFactoryProperty = {
  Type: 'type',
  ControlProps: 'controlProps',
};

export default {
  ControlFactoryProperty,
};
